// v3.4.250 — حجوزات دليلك — صفحة مستقلة في القائمة الجانبية (قسم نظام التسويق)
// كانت تابًا داخل «العملاء المحتملون» (v3.4.236 → v3.4.247)؛ نُقلت بطلب المشغّل لتكون بندًا رئيسيًا.
// التحويل من عميل محتمل إلى حجز يصل عبر location.state.prefill من صفحة العملاء المحتملين.
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DalilakReservationsTab, SalesDashboardTab } from "./ClientProspectsPage"; // v3.4.251 — + داشبورد المبيعات

export default function DalilakReservationsPage() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminUser = (user?.role === "admin" && !user?.impersonating) || user?.is_admin;
  const canAdd = isAdminUser || user?.cp_can_add_dalilak_reservations;
  const canView = isAdminUser || user?.cp_can_view_dalilak_reservations || user?.cp_can_add_dalilak_reservations;
  const [prefill, setPrefill] = useState(() => location.state?.prefill || null);
  const canViewSales = isAdminUser || user?.cp_can_view_sales_dashboard; // v3.4.251
  const [tab, setTab] = useState("list"); // v3.4.251 — list | sales

  if (!canView) {
    return <div style={{ padding: 40, textAlign: "center", color: "#b45309", fontSize: 14 }}>ليس لديك صلاحية عرض حجوزات دليلك</div>;
  }
  return (
    <div style={{ padding: "20px 24px", direction: "rtl" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <span style={{ fontSize: 20 }}>🏠</span>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#0f172a" }}>حجوزات دليلك</h2>
      </div>
      {/* v3.4.251 — تابان داخليان: كشف الحجوزات + داشبورد المبيعات (كان تابًا في صفحة العملاء المحتملين) */}
      {canViewSales && (
        <div style={{ display: "flex", gap: 4, borderBottom: "2px solid #e2e8f0", marginBottom: 14 }}>
          {[["list", "📋 كشف الحجوزات"], ["sales", "💰 داشبورد المبيعات"]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)}
              style={{ padding: "9px 16px", background: "none", border: "none", borderBottom: tab === k ? "3px solid #0f766e" : "3px solid transparent",
                marginBottom: -2, color: tab === k ? "#0f766e" : "#64748b", fontWeight: tab === k ? 800 : 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
          ))}
        </div>
      )}
      {(tab === "list" || !canViewSales) && <DalilakReservationsTab canAdd={canAdd} prefill={prefill} onPrefillDone={() => { setPrefill(null); navigate(location.pathname, { replace: true, state: null }); }} />}
      {tab === "sales" && canViewSales && <SalesDashboardTab />}
    </div>
  );
}
